module.exports = __webpack_public_path__ + "static/img/eboard-factory-new_org.c1cf97f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eboard-factory-new_org.png
// module id = 6aeu
// module chunks = 1